import { useEffect, useMemo, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  useTheme,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

import {
  useGetCurrentUserQuery,
  useUpdateUserMutation,
} from '@/apis/extended/userApi';
import { CommonFormControl } from '../Common/CommonFormControl';
import { CommonPhoneInput } from '../Common/CommonPhoneInput';

const initialForm = {
  name: '',
  phone: '',
};

export const ProfilePersonalInformation = () => {
  const theme = useTheme();
  const { data, isFetching } = useGetCurrentUserQuery();
  const [updateUser, { isLoading: isUpdatingUser }] = useUpdateUserMutation();
  console.log('data', data);

  const [form, setForm] = useState({ ...initialForm });

  useEffect(() => {
    setForm({
      name: data?.name || '',
      phone: data?.phone || '',
    });
  }, [data]);

  const isUpdated = useMemo(() => {
    return form.name !== data?.name || form.phone !== data?.phone;
  }, [form, data]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    updateUser(form);
  };

  return (
    <>
      <Card
        sx={{
          mt: 2,
          border: `1px solid ${theme.palette.greyShades.border1}`,
          boxShadow: `0 2px 12px ${alpha(theme.palette.common.black, 0.05)}`,
        }}
      >
        <CardHeader
          title="Personal Information"
          titleTypographyProps={{
            variant: 'h6',
            sx: { color: 'text.primary', fontWeight: 600 },
          }}
          avatar={
            <i
              className="fa-light fa-gear"
              style={{ color: theme.palette.primary.main, fontSize: '1.35rem' }}
              aria-hidden
            />
          }
        />
        <CardContent>
          <CommonFormControl label="Name:">
            <TextField
              placeholder="Name"
              name="name"
              value={form.name}
              onChange={handleInputChange}
            />
          </CommonFormControl>
          <CommonFormControl label="Email:" sx={{ mt: 1 }}>
            <TextField
              placeholder="Email"
              name="email"
              disabled
              value={data?.email || ''}
            />
          </CommonFormControl>
          <CommonFormControl label="Phone Number:" sx={{ mt: 1 }}>
            <CommonPhoneInput
              value={form.phone}
              onChange={(value) => {
                setForm({ ...form, phone: value });
              }}
            />
          </CommonFormControl>
          <CommonFormControl sx={{ mt: 1 }}>
            <LoadingButton
              loading={isFetching || isUpdatingUser}
              disabled={!isUpdated}
              variant="contained"
              color="primary"
              startIcon={<i className="fa-light fa-pencil" />}
              onClick={handleSave}
              sx={{ fontWeight: 600, borderRadius: 2, px: 3, py: 1.25 }}
            >
              Save
            </LoadingButton>
          </CommonFormControl>
        </CardContent>
      </Card>
    </>
  );
};
